import { RecordStore } from '@deqo/foundation';
import { WorkspaceLiteData } from '../../../api/ApiTypes';
import { HomeData } from '../../../api/endpoints/me';

const template = {
    workspaces: [] as WorkspaceLiteData[],
};

export class NavigationModel extends RecordStore(template) {

    public static create({ workspaces }: HomeData) {
        const m = new NavigationModel();
        m.updateState({ workspaces });
        return [m, m.updateState.bind(m) as NavigationModel['updateState']] as const;
    }

}
